import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { LEASING_ACCESS_PERMISSION, LEASING_PATH } from '&/features/leasing/paths';
import { requireModule } from '&/lib/module-gate';

// The Leasing area (SWOOP-298). One guard for every Leasing page beneath it: each child supplies its own
// page shell, so this layout only renders the Outlet.
export const Route = createFileRoute('/_authenticated/leasing')({
  beforeLoad: ({ context }): void => {
    // Entitlement: a tenant without the module that owns this path (per the registry) gets the
    // standard not-found. Covers client-side navigation only; each page wraps itself in <ModuleGate>
    // for the hard-refresh case.
    requireModule(context.entitlement, LEASING_PATH);
    // Permission gate (separate concern): an entitled tenant's user without Leasing access goes back to
    // the Dashboard, as a denied top-level page does (see `vehicles.tsx`).
    if (context.permissions.isReady && !context.permissions.hasPermission(LEASING_ACCESS_PERMISSION)) {
      throw redirect({ to: '/' });
    }
  },
  component: Outlet,
});
